import { getFlagActiveVariationsFromIdBasedConfig } from './getFlagActiveVariationsFromIdBasedConfig';
import { isFlagOnForEnvironment } from './isFlagOnForEnvironment';
import type { FeatureFlag, FeatureFlagConfig, Variation } from './types';

/**
 * Returns the active variations for an index-based {@link FeatureFlagConfig}.
 *
 * Converts indices to variation IDs and delegates to
 * {@link getFlagActiveVariationsFromIdBasedConfig}.
 */
export function getFlagActiveVariationsFromConfig(
  config: FeatureFlagConfig,
  variations: FeatureFlag['variations'],
): Array<[variationIndex: number, variation: Variation]> {
  const toId = (index: number | undefined): string | undefined => variations[index ?? -1]?._id;

  return getFlagActiveVariationsFromIdBasedConfig(
    {
      on: isFlagOnForEnvironment(config),
      offVariationId: toId(config.offVariation),
      targets: config.targets?.map((t) => ({ variationId: toId(t.variation) ?? '' })),
      contextTargets: config.contextTargets?.map((t) => ({ variationId: toId(t.variation) ?? '' })),
      rules: config.rules?.map((r) => ({
        variationId: toId(r.variation),
        rollout: r.rollout && {
          variations: r.rollout.variations.map((wv) => ({
            variationId: toId(wv.variation) ?? '',
            weight: wv.weight,
          })),
        },
      })),
      fallthrough: config.fallthrough && {
        variationId: toId(config.fallthrough.variation),
        rollout: config.fallthrough.rollout && {
          variations: config.fallthrough.rollout.variations.map((wv) => ({
            variationId: toId(wv.variation) ?? '',
            weight: wv.weight,
          })),
        },
      },
    },
    variations,
  );
}
